
import { PaymentTermOption } from "../../account/constants/dealer-basic-data";
import { Currency, GeneralBasicData } from "../../common/constants/general-basic-data";
import { PhoneNumber } from "../../common/models/address.model";
import { Payment } from "../../common/models/payment.model";
import { Price } from "../../common/models/string-data.model";
import { RentalMileageOption, RentalInsuranceOption, BookingStatus, BookingAction } from "../constants/rent-basic-data";
import { BookingModif } from "./booking-modif.model";

 export class Booking {

   id = 0;

   customerId = "";
   customerName = "";
   customerBusinessName = "";
   customerLocation = "";
   customerPhoneNumber: PhoneNumber = new PhoneNumber();
   customerEmail = "";

   carId = "";
   carInfoSummary = "";

   offerId = '';
   offerTitle = '';
   offerDescription = '';
   offerPosted = false;
   offerClosed = false;
   offerStartDate = '';
   offerEndDate = '';
   offerDayRate: Price = Price.getDefault()

   customerDriving = true;
   withDriver = false;
   startDate = "";
   endDate = "";

   mileageOption: RentalMileageOption = RentalMileageOption.STANDARD;
   insuranceOption: RentalInsuranceOption  = RentalInsuranceOption.STANDARD;
   paymentTermOption: PaymentTermOption = PaymentTermOption.PAY_NOW;

   country = "";
   currency: Currency = GeneralBasicData.getDefaultCurrency();
   totalDays = 0; 

   insuranceDayRate = 0; 
   driverDayRate = 0; 
   carDayRate = 0; 

   insuranceAmount = 0; 
   driverAmount = 0; 
   carAmount = 0; 
   totalAmountToPay = 0; 

   driverCompany = "";
   driverFirstName = "";
   driverLastName = "";
   driverAgeMin = 0;

   driverEmail = "";
   driverPhoneNumber: PhoneNumber = new PhoneNumber();

   driverIdCardNo = "";
   notes = "";

   status: BookingStatus = BookingStatus.DRAFT;

   initialPayment: Payment = new Payment();
   payments: Payment [] = []

   completedPrice: Price= Price.getDefault();
   completedDate = "";
   completedNotes = "";

   created = "";
   lastUpdated = "";
   createdBy = "";
   lastUpdatedBy = "";

   dealerActions: BookingAction[] = [];
   modification?: BookingModif = new BookingModif();

   constructor(){
      this.dealerActions = [] 
   }

   getTotalDuration(): number {
      var duration = 1 + (new Date(this.endDate).getTime() - new Date(this.startDate).getTime())/(3600*24000);
      return duration > 0 ? duration : 0;
      }

   getTotalAmount(): number{
      return this.carAmount+this.insuranceAmount+this.driverAmount;
   }

 }
